import React, { useState, useEffect } from 'react';
import Layout from './Layout';
import '../styles/NotFound.css';

const NotFound: React.FC = () => {
  const [currentIcon, setCurrentIcon] = useState(0);
  const [showAnimation, setShowAnimation] = useState(false);

  const professionIcons = ['', '', '', '', ''];
  const professionNames = ['dažytojas', 'elektrikas', 'santechnikas', 'stalias', 'stogdengys'];

  const phrases = [
    'Net mūsų AI asistentas negali rasti šio puslapio...',
    'Čia tikrai nėra jokių darbų - puslapis nerastas!',
    'Matyt, šis puslapis išėjo į atostogas...',
    'Ups! Puslapis dingo greičiau nei blogas klientas!',
    'Šis puslapis kaip nemokantis klientas - tiesiog neegzistuoja.'
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIcon(prev => (prev + 1) % professionIcons.length);
    }, 2000);

    const animationTimer = setTimeout(() => {
      setShowAnimation(true);
    }, 500);

    return () => {
      clearInterval(interval);
      clearTimeout(animationTimer);
    };
  }, [professionIcons.length]);

  const handleGoHome = () => {
    window.location.href = '/';
  };

  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <Layout>
      <div className="not-found-container">
        <div className="not-found-content">

          {/* Animated 404 with profession icons */}
          <div className="error-code-section">
            <div className="error-code">
              <span className="error-digit">4</span>
              <div className="error-icon-container">
                <span className={`profession-icon ${showAnimation ? 'animated' : ''}`}>
                  {professionIcons[currentIcon]}
                </span>
              </div>
              <span className="error-digit">4</span>
            </div>
            <div className="profession-label">
              {professionNames[currentIcon]}
            </div>
          </div>

          {/* Main message */}
          <div className="error-message">
            <h1 className="error-title">Ups! Puslapis nerastas</h1>
            <p className="error-subtitle">
              {phrases[currentIcon]}
            </p>
          </div>

          {/* Helpful suggestions */}
          <div className="error-suggestions">
            <h3>Kas galėjo nutikti?</h3>
            <ul>
              <li> Puslapis buvo perkeltas į kitą adresą</li>
              <li> Nuoroda neteisingai nukopijuota</li>
              <li> Serveris laikinai nepasiekiamas</li>
              <li> Mes atnaujinome svetainės struktūrą</li>
            </ul>
          </div>

          {/* Action buttons */}
          <div className="error-actions">
            <button onClick={handleGoHome} className="btn-cta">
               Grįžti į pradžią
            </button>
            <button onClick={handleGoBack} className="btn-secondary">
              ← Grįžti atgal
            </button>
          </div>

          {/* Quick links */}
          <div className="quick-links">
            <h4>Populiarūs puslapiai:</h4>
            <div className="quick-links-grid">
              <a href="/registracija" className="quick-link">
                <span className="quick-link-icon"></span>
                <span>Registracija</span>
              </a>
              <a href="/kainos" className="quick-link">
                <span className="quick-link-icon"></span>
                <span>Kainos</span>
              </a>
              <a href="/pagalba" className="quick-link">
                <span className="quick-link-icon">❓</span>
                <span>Pagalba</span>
              </a>
              <a href="/kontaktai" className="quick-link">
                <span className="quick-link-icon"></span>
                <span>Kontaktai</span>
              </a>
            </div>
          </div>

          {/* Fun contact section */}
          <div className="error-contact">
            <div className="contact-card">
              <h4> Reikia pagalbos?</h4>
              <p>Mūsų AI asistentas visada čia, kad padėtų!</p>
              <a href="/kontaktai" className="btn-outline">
                Susisiekti su mumis
              </a>
            </div>
          </div>

        </div>
      </div>
    </Layout>
  );
};

export default NotFound;